export enum YLRecommendPriorityEnum {
  INIT = -1,
  LOW = 0,
  MIDDLE = 1,
  HIGH = 2,
}
